import { render, staticRenderFns } from "./auction-house-item.vue?vue&type=template&id=3793dcfd&scoped=true&"
import script from "./auction-house-item.vue?vue&type=script&lang=js&"
export * from "./auction-house-item.vue?vue&type=script&lang=js&"
import style0 from "./auction-house-item.vue?vue&type=style&index=0&id=3793dcfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3793dcfd",
  null
  
)

export default component.exports